import { Component, Input, OnInit } from '@angular/core';
import { CalendarEvent } from 'calendar-link';

import {
  buildCalendarLink,
  calendarProviderConfigs,
  downloadIcs,
} from '@libs/src/calendar-links/calendar-links.helper';
import { CalendarProviders } from '@libs/src/calendar-links/calendar-providers.type';

import includes from 'lodash-es/includes';

@Component({
  selector: 'app-add-to-calendar-chips',
  templateUrl: './add-to-calendar-chips.component.html',
})
export class AddToCalendarChipsComponent implements OnInit {
  @Input() calendarEvent: CalendarEvent;
  @Input() supportedProviders: CalendarProviders;
  calendarLinks: { [key: string]: string } = {};
  calendarProviders = [];

  ngOnInit(): void {
    this.calendarLinks = buildCalendarLink(this.calendarEvent);
    this.calendarProviders = calendarProviderConfigs
      .filter(({ name }) => includes(this.supportedProviders, name))
      .map((config) => ({
        ...config,
        calendarUrl: this.calendarLinks[config.name],
      }));
  }

  downloadIcsForEvent(icsString) {
    downloadIcs(icsString, 'event');
  }
}
